(() => {
  const isMobileDevice =
    /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isMobileDevice) return;

  const update = () => {
    const landscape = window.innerWidth > window.innerHeight;
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach((product) => {
      const changed = product.classList.contains('adya-landscape-product') !== landscape;
      product.classList.toggle('adya-landscape-product', landscape);
      if (changed) {
        requestAnimationFrame(() => {
          product.querySelector('media-gallery > slider-component')?.initPages?.();
        });
      }
    });
  };

  update();
  if (window.adyaProductLandscapeInitialized) return;
  window.adyaProductLandscapeInitialized = true;
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('orientationchange', update, { passive: true });
  document.addEventListener('shopify:section:load', update);
})();
